/* @refresh reload */
import { render } from 'solid-js/web'
import { Router } from '@solidjs/router'
import { StateProvider } from './context/StateContext'
import App from './App'
import './index.css'

const root = document.getElementById('root')

render(() => (
  <Router>
    <StateProvider>
      <App />
    </StateProvider>
  </Router>
), root!)
